import { ExportRecsView } from "./export-recs-view";
import { useExportRecs } from "./use-export-recs";

export const ExportRecs = () => {
  const logic = useExportRecs();
  return <ExportRecsView {...logic} />;
};
